
export const IS_LOCAL = process.env.NODE_ENV !== 'production';
export const TEST_API_URL = 'https://platform-test.hzwxbz999.cn/';
export const REL_API_URL = '//platform-pre.hzwxbz999.cn/';
export const PRO_API_URL = '//platform.hzwxbz2.cn/';

export const getApiUrl = () => {
  switch (window.location.hostname) {
    case 'platform-box-h5-ios-test.hzwxbz999.cn':
      return TEST_API_URL;
    case 'platform-box-h5-ios-pre.hzwxbz999.cn':
      return REL_API_URL;
    default:
      return PRO_API_URL;
  }
};

// export const API_URL = '//172.16.20.70:10091'; // @todo 后端本地起服务 开发完成需要注释还原
export const API_URL = IS_LOCAL ? TEST_API_URL : getApiUrl();